import { atom } from 'jotai';

import {
  AlignedBoundingBox,
  Number3,
  Transform,
  TransformControlsMode,
} from '@fabric-web/3d-viewer';

export const sceneBoundingBox = atom<AlignedBoundingBox>();

export const isScansVisible = atom<boolean>(true);
export const isCadVisible = atom<boolean>(true);

export const transformMode = atom<TransformControlsMode>();

export const activeAxes = atom<{
  translate: string;
  rotate: string;
  scale: string;
}>({ translate: 'XY', rotate: 'Z', scale: 'XYZ' });

export const scansTransformWithHistory = atom<{
  history: Transform[];
  undoIndex: number;
  lastUpdateTime: number;
  transformMode: TransformControlsMode | undefined;
}>();

export const rotationCenter = atom<Number3>();
export const isWaitingForRotationCenter = atom<boolean>(false);
